export const availableLanguages = ['es', 'en', 'fr', 'it', 'de', 'pt', 'nl', 'ko']
